module.exports = __webpack_public_path__ + "img/forage1.cbd0563c.png";